module.exports = __webpack_public_path__ + "img/icon_loop_unselected.029d2e2a.png";